import { Icon } from "@iconify/react";
import type { HtmlHTMLAttributes } from "react";

interface ButtonIconProps extends HtmlHTMLAttributes<HTMLButtonElement> {
  icon: string;
  spin?: boolean;
}

export default function ButtonIcon({
  className,
  icon,
  spin,
  ...res
}: ButtonIconProps) {
  return (
    <button
      {...res}
      className={`${className} w-11 cursor-pointer duration-150 hover:scale-110 hover:bg-current/10! flex-center text-2xl! h-11 rounded-full`}
    >
      <Icon
        icon={icon}
        className={`${
          spin ? "animate-spin [animation-duration:12s]" : ""
        } text-current!`}
      />
    </button>
  );
}
